import { Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { MultiTenantCasesSkeleton } from '@/features/air/multi-tenant/components/skeletons'
import { validateMultiTenantCasesSearch } from '@/features/air/multi-tenant/lib/cases-search'
import { prefetchMultiTenantCases } from '@/features/air/multi-tenant/queries'
import { lazyNamed } from '@/utils/lazy-named'

import { ErrorBoundary } from '@/components/common/error-boundary'

const CasesTable = lazyNamed(
	() => import('@/features/air/multi-tenant/components/cases-table'),
	'CasesTable',
)

export const Route = createFileRoute('/_dashboard/multi-tenant/_layout/cases')({
	// The same Case filter params as `/air/case-management`.
	validateSearch: validateMultiTenantCasesSearch,
	// `t`: the catalog prefetch is keyed by the current tenant (GOTCHAS).
	loaderDeps: ({ search }) => ({
		t: search.t,
		tenants: search.tenants,
		filters: search.filters,
		openedAfter: search.openedAfter,
		openedBefore: search.openedBefore,
		q: search.q,
	}),
	loader: ({ deps, context: { queryClient } }) =>
		prefetchMultiTenantCases(queryClient, deps),
	component: CasesTab,
	pendingComponent: MultiTenantCasesSkeleton,
})

/**
 * The tab is one data section. Its boundary keeps a failed Case list inside
 * the tab, so the layout's title, tenant picker and tabs stay (P-19).
 */
function CasesTab() {
	return (
		<ErrorBoundary feature="multi-tenant" section="cases">
			<Suspense fallback={<MultiTenantCasesSkeleton />}>
				<CasesTable />
			</Suspense>
		</ErrorBoundary>
	)
}
